import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IFormSelectOption } from 'src/app/modules/shared/models/forms';
import { BeneficiaryFormIsvComponent } from '../beneficiary-form-isv/beneficiary-form-isv.component';
import { EPolicyCompany, IPagatore, UserActivityScope } from 'src/app/modules/shared/models/policy.model';
import { CLOSE_BUTTON, CONFIRM_BUTTON, EModalOutput } from 'src/app/modules/shared/components/basic-modal/basic-modal.constants';
import { take } from 'rxjs';
import { LoggerService } from 'src/app/services/logger.service';
import { userKeys } from './payer-variation.constant';
import { IPayerVariationUpdate } from '../beneficiary-change-isv/beneficiary-change-isv.constants';

@Component({
  selector: 'app-payer-variation',
  templateUrl: './payer-variation.component.html',
  styleUrl: './payer-variation.component.scss'
})
export class PayerVariationComponent {

  @Input() payersList: IPagatore[];
  @Input() countriesList: IFormSelectOption[]
  @Input() provinceList: IFormSelectOption[]
  @Input() comuniList: IFormSelectOption[]
  @Input() documentTypeList: IFormSelectOption[]
  @Input() documentReleaseAuthorityList: IFormSelectOption[]

  @Output() onPayerUpdate = new EventEmitter<IPayerVariationUpdate>();
 
  userKeys = userKeys
  constructor(private readonly _dialog: MatDialog){

  }

  mapPayerToBeneficiaryObjectFormat(payer: IPagatore): any {
    return {
      beneficiaries: [{
        personData: {
          personType: payer?.naturaGiuridica === 'F' ? 'Fisica' : 'Giuridica',
          ...payer,
          addresses: [{
            ...payer?.indirizzoNascita
          }],
        },

      }]
    }
  }

  openNewBeneficiaryModal(payer?: IPagatore): void {
    this._dialog.open(BeneficiaryFormIsvComponent, {
      data: {
        policyCompany: EPolicyCompany.ISP,
        userActivityScope: UserActivityScope.PAGATORE,
        beneficiaryType: [{ key: '6', value: "Pagatori nominativi" }],
        provincesList: this.provinceList,
        comuniList: this.comuniList,
        documentTypesList: this.documentTypeList,
        documentReleaseAuthoritesList: this.documentReleaseAuthorityList,
        isReadOnly: false,
        //beneficiary: this.mapPayerToBeneficiaryObjectFormat(payer),
        countriesList: this.countriesList,
        buttons: [
          CLOSE_BUTTON,
          CONFIRM_BUTTON
        ]
      },
      minWidth: '70vw',
      minHeight: '55vh',
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(outcome => {
        if (outcome && outcome.command === EModalOutput.CONFIRM) {
          LoggerService.logInfo(this.constructor.name, 'openNewPayerModal', { outcome });
          const payerData = outcome?.output?.beneficiaries
          this.payersList = [{
            nome: payerData.beneficiario.nome,
            cognome: payerData.beneficiario.cognome,
            codiceFiscale: payerData.beneficiario.codiceFiscale,
            dataNascita: payerData.anagrafica.dataNascita,
          }]

          const payerToUdpate : IPayerVariationUpdate = {
            idAnagrafico: payerData.beneficiario.idAnagrafico,
            nome: payerData.beneficiario.nome,
            cognome: payerData.beneficiario.cognome,
            codiceFiscale: payerData.beneficiario.codiceFiscale,
            sesso: payerData.anagrafica.sesso,
            dataNascita: payerData.anagrafica.dataNascita,
            naturaGiuridica: payerData.beneficiario.personType === 'Persona Fisica' ? 'F' : 'F',
            documento: {
              dataFineValidita: payerData.anagrafica.documento.dataFineValidita,
              dataRilascio: payerData.anagrafica.documento.dataRilascio,
              codiceDocumentoRiconoscimento: payerData.anagrafica.documento.codiceDocumentoRiconoscimento,
              codiceEnteRilascio: payerData.anagrafica.documento.codiceEnteRilascio,
              descrizioneEnteRilascio: payerData.anagrafica.documento.descrizioneEnteRilascio,
              descrizioneTipoDocumento: payerData.anagrafica.documento.descrizioneTipoDocumento,
              numeroDocumento: payerData.anagrafica.documento.numeroDocumento,
              luogoRilascio: payerData.anagrafica.documento.luogoRilascio,
            },
            indirizzoNascita: {
              cap: payerData.anagrafica.indirizzoNascita.postalCode,
              via: payerData.anagrafica.indirizzoNascita.address,
              localita: payerData.anagrafica.indirizzoNascita.localita,
              provincia: payerData.anagrafica.indirizzoNascita.provincia,
              codiceNazione: payerData.anagrafica.indirizzoNascita.nazione
            }
          }
          this.onPayerUpdate.emit(payerToUdpate);
        }
      }
      )
  }

  deletePayer() {
    this.payersList = [];
    this.onPayerUpdate.emit(undefined);
  }

  modifyPayer(payer: IPagatore): void {
    LoggerService.logInfo(this.constructor.name, 'modifyPayer', payer);
    this.openNewBeneficiaryModal(payer)
  }

}
